import { memo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Logo } from "../common/Logo";
import { StopFreeSaleExportTable } from "./StopFreeSaleExportTable";
import { enmStopFreeSale } from "../../models/enums/StopFreeSale";
import dayjs from "dayjs";
import { mdlStopFreeSaleExport } from "../../models/domain/StopFreeSaleExport";
import { mdlStopFreeSaleDetail } from "../../models/domain/StopFreeSaleDetail";
import _ from "lodash";
import { mdlStopFreeSaleMessage } from "../../models/domain/StopFreeSaleMessage";
import { Image } from "antd";

export type StopFreeSaleExportTemplateProps = {
    dataSource?: mdlStopFreeSaleExport;
    fnAgencyMailPreview?: Function;
    detail?: mdlStopFreeSaleDetail[];
    message?:mdlStopFreeSaleMessage;
    stopFreeSaleType?: enmStopFreeSale;
}

export const StopFreeSaleExportTemplate = memo(function StopFreeSaleExportTemplate(props: StopFreeSaleExportTemplateProps) {
    const { t } = useTranslation();
    
    useEffect(() => {
    }, []);
    const getHeaderText = () => {
        const type = props.stopFreeSaleType != undefined ? (props.stopFreeSaleType == enmStopFreeSale.StopSale ? false : true) : _.first(props.detail)?.type as boolean;
        const hotelName:string = props.dataSource?.hotelName ?? "";
        let result:string = `${t("common.hello")}, <br><br> `
        let message:string | undefined = undefined;
      if(props.message != undefined){
            if(!type){
                message = props.message.stopMessage;
            }else{
                message = props.message.freeMessage;
            }
        }
        if(message){
            result += message.replace("@Hotel", hotelName)
            .replace("@Type", type  ? t("stopFreeSale.create.stopSale") : t("stopFreeSale.create.freeSale"));
        }else{
            if(props.dataSource?.status == "Y"){
                result += t("stopFreeSaleExportTable.newMessage").replace("@Hotel", hotelName)
                .replace("@Type", type  ? t("stopFreeSale.create.stopSale") : t("stopFreeSale.create.freeSale"));
        }else{
                result += t("stopFreeSaleExportTable.cancelMessage").replace("@Hotel", hotelName)
                .replace("@Type", type  ? t("stopFreeSale.create.stopSale") : t("stopFreeSale.create.freeSale"));
            }
        }
        return result;
    }
    return (
        <>
            {
                props.dataSource
                &&
                <>
                <div className="row">
                    <div className="col-12 text-center mb-4">
                        <Image src={`${process.env.REACT_APP_AMAZON_URI}hotel/${props.dataSource.hotelId}/Thumb/logo.png?ver=${Math.floor(Math.random() * parseFloat(dayjs().day.toString()))}`}></Image>
                    </div>
                    <div className="col-12">
                        <p dangerouslySetInnerHTML={{ __html: getHeaderText() }} />
                        <p><b>{t("stopFreeSaleExportTable.status")} : </b> {props.dataSource?.status && props.dataSource?.status == "Y" ? t("stopFreeSaleTable.new") : t("stopFreeSaleTable.cancel") }</p>
                        <p><b>{t("stopFreeSaleExportTable.dateRange")} : </b>{dayjs(props.dataSource?.startDate).format("DD-MM-YYYY")} - {dayjs(props.dataSource?.endDate).format("DD-MM-YYYY")}</p>
                        <p><b>{t("stopFreeSaleExportTable.applicationType")} : </b> {props.dataSource?.checkInStay == 0 ? t("stopFreeSaleExportTable.stopFreeStay"): t("stopFreeSale.stopFreeCheckIn")}</p>
                        <p><b>{t("stopFreeSaleExportTable.note")} : {props.dataSource?.note}</b></p>
                        
                    </div>
                    <div className="col-12">
                        <div className="mobile-ant-d-table">
                            <StopFreeSaleExportTable fnAgencyMailPreview={props.fnAgencyMailPreview} dataSource={props.detail}></StopFreeSaleExportTable>
                        </div>
                    </div>
                </div>
                </>
            }
        </>
    )
})